import images from "../../../images";
import Svg from "../../Helper/Svg";
import translate from "../../../Utils/translate";

const MasterPasswordMessage = () => {
  return (
    <section className="text-sm mt-1 mb-default">
      <div className="flex justify-center mb-16">
        <Svg icon={images.illustrations.lock} />
      </div>

      <p className="text-justify">{translate("pages.register.master_password")}</p>
    </section>
  );
};

export default MasterPasswordMessage;
